var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{},[(!_vm.isiFrame)?_c('client-logo'):_vm._e(),(!_vm.isiFrame)?_c('tab-header'):_vm._e(),_c('div',{staticClass:"page",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"container large"},[_c('router-view',{attrs:{"name":"overview"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }